export const isAndroid = () => /android/i.test(navigator.userAgent);
